<template>
    <div class="classify">
        <div class="">
            <h1>
                <textLoading class="loading" v-if="statusText"></textLoading>
                <!-- <span class="loading" v-if="statusText"><img src="@/assets/image/loading.png"  alt=""></span> -->
                <span class="title">{{ title }}</span>
                <!-- <span class="statusText">{{ statusText }}</span> -->
                <span class="statusText" v-if="activeName === 'cs'">字数 {{ textContentLength('cs') }}</span>
                <span class="statusText" v-if="activeName === 'fx'">字数 {{ textContentLength('fx') }}</span>
            </h1>
            <el-tabs class="tabs" v-model="activeName" :before-leave="beforeLeaveClick">
                <el-tab-pane label="转换结果" name="zh"></el-tab-pane>
                <!-- <el-tab-pane label="仿写结果" name="fx"></el-tab-pane> -->
            </el-tabs>
        </div>

        <div class="main" ref="csRef" v-if="activeName === 'cs'" v-html="csText">
        </div>
        <!-- <div class="main" ref="fxRef" v-if="activeName === 'fx'" v-html="fxText">
        </div> -->
        <div class="bottom-btn">
            <el-button class="btn default" @click="copyInnterText()"><span>复制</span></el-button>
            <el-button @click="afreshClick('cs')" v-if="this.$attrs.result || csText" class="btn t-m-l-24">
                <span>重新转换</span>
            </el-button>
            <!-- <el-button @click="afreshClick('fx')" v-if="this.$attrs.result && fxText" class="btn t-m-l-24">
                <span>重新仿写</span>
            </el-button> -->
            <!-- <el-button @click="afreshClick('fx')" v-if="this.$attrs.result && !fxText" class="btn t-m-l-24">
                <span>我要仿写</span>
            </el-button> -->
        </div>
        <!-- 停止生成按钮 -->
        <AIStopCreate :hide="statusText" emit @stop="stopPolling"></AIStopCreate>
        <popup ref="delPopup" @confirm="confirm"></popup>
    </div>

</template>
<script>
import apart from '@/api/apart';
import _ from 'lodash'
import { copy } from '@/utils/utils'
import popup from '@/components/dongeb/popup.vue';
import textLoading from '@/components/text_loading.vue';
export default {
    components: {
        popup, textLoading
    },
    data() {
        return {
            title: sessionStorage.getItem('title'),
            generatorId: 0,
            times: null,
            index: 0, //记录上次响应的长度,
            csText: '', // 拆书内容
            fxText: '',// 仿写内容
            pollingInterval: 500, // 轮询定时器
            typewriterSpeed: 20, // 打字机效果速度(ms)
            statusText: false,//表示加载行为， 
            streamLast: false,//表示最后请求的状态
            isStop: false,
            activeName: 'cs'
        }
    },
    computed: {
        resultContent() {
            return this.$attrs.result
        },
    },
    watch: {
        resultContent: {
            handler(newVal) {
                console.log('当拆书生成结束的时候有新的变化=');
                //没有拆书结果就先AI生成
                this.statusText = false
                let chapterData = JSON.parse(sessionStorage.getItem('chapterData'))
                if (chapterData && chapterData.chapterId) {
                    this.activeName = chapterData.sign
                    if (this.activeName === 'cs') {
                        // this.fxText = this.replaceText(sessionStorage.getItem(this.$attrs.chapterId + '_fxText'))
                        apart.scriptUnpack(chapterData).then(res => {
                            if (res.code === 200) {
                                this.statusText = true
                                this.getGeneratorText(res.data)
                            }
                        }).catch(() => {
                            this.statusText = false
                        }).finally(() => {
                            sessionStorage.removeItem('chapterData')
                        });
                    }
                    //  else if (this.activeName === 'fx') {
                    //     this.csText = this.replaceText(sessionStorage.getItem(this.$attrs.chapterId + '_csText'))
                    //     apart.mimicCreate(chapterData).then(res => {
                    //         if (res.code === 200) {
                    //             this.statusText = true
                    //             this.getGeneratorText(res.data)
                    //         }
                    //     }).catch(() => {
                    //         this.statusText = false
                    //     }).finally(() => {
                    //         sessionStorage.removeItem('chapterData')
                    //     });
                    // }


                } else {
                    //这里只显示结果
                    if (this.$attrs.result) {
                        // console.log(this.$attrs.result)
                        this.activeName = 'cs'
                        this.csText = this.replaceText(this.$attrs.result);
                        // this.fxText = this.replaceText(sessionStorage.getItem(this.$attrs.chapterId + '_fxText'))
                        this.scrollToTop('csRef')
                    }
                }
            },
            immediate: true,
        }
    },
    methods: {
        //tabs切换之前的事件
        beforeLeaveClick(activeName, oldActiveName) {
            if (this.statusText) {
                this.$refs.delPopup.openPrompt(10);
                return false
            }
            this.activeName = activeName
            // console.log(this.$attrs.result)
            if (this.activeName === 'cs') {
                this.scrollToTop('csRef')
            } 
            // else if (this.activeName === 'fx') {
            //     this.scrollToTop('fxRef')
            // }
            return true
        },
        afreshClick(type) {
            if (this.statusText) {
                this.$refs.delPopup.openPrompt(10);
                return
            }
            sessionStorage.setItem(this.$attrs.chapterId + '_csText', this.csText)
            // sessionStorage.setItem(this.$attrs.chapterId + '_fxText', this.fxText)
            //  sessionStorage.setItem('apartStatus', JSON.stringify({ id: this.$attrs.chapterId, status: 'ok' }))
            if (type === 'cs') {
                this.$emit('unpack', 'classify')
            }
            // if (type === 'fx') {
            //     this.$emit('unpack', 'mimic')
            // }

        },
        confirm() {
            this.$refs.delPopup.close()
        },
        async copyInnterText() {
            let text = ''
            if (this.activeName === 'cs') {
                text = this.stripHtmlTags(this.csText)
            }
            if (this.activeName === 'fx') {
                text = this.stripHtmlTags(this.fxText)
            }
            const success = await copy(text);
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
        stopPolling(isStop) {
            if (isStop) {
                sessionStorage.setItem(this.$attrs.chapterId + '_csText', this.csText)
                // sessionStorage.setItem(this.$attrs.chapterId + '_fxText', this.fxText)
                sessionStorage.setItem('apartStatus', JSON.stringify({ id: this.$attrs.chapterId, status: 'ok' }))
            }
            clearTimeout(this.times);
            clearInterval(this.typewriterInterval);
            this.streamLast = false
            this.statusText = false
        },
        getGeneratorText(id) {
            // 清除之前的定时器
            if (this.times) {
                clearTimeout(this.times);
            }
            this.times = setTimeout(() => {
                // console.log('执行轮询');
                apart.generatorText(id, { index: this.index }).then(result => {
                    if (result.code === 200) {
                        if (result.data && result.data.length > 0) {
                            this.index += result.data.length; //记录下次请求的索引
                            this.processNewTextChunks(id, result.data);
                        } else {
                            this.getGeneratorText(id)
                        }
                    }
                }).catch(() => {
                    this.statusText = false
                })
            }, this.pollingInterval);
        },
        // 处理新的文本片段
        processNewTextChunks(id, newChunks) {
            let combinedText = '';
            newChunks.forEach(item => {
                if (item !== '[DONE]') {
                    sessionStorage.setItem('apartStatus', JSON.stringify({ id: this.$attrs.chapterId, status: 'loading' }))
                    // 添加到累积文本
                    combinedText += item;
                }
            });
            if (this.activeName === 'cs') {
                this.csText = this.replaceText(this.csText);
            }

            // 打印机效果
            this.startTypewriterEffect(combinedText, () => {
                //如果最后1行出现done说明完结，停止轮询
                if (newChunks[newChunks.length - 1] === '[DONE]') {
                    this.index = 0;
                    this.streamLast = true
                }
                if (this.streamLast) {
                    sessionStorage.setItem(this.$attrs.chapterId + '_csText', this.csText)
                    // sessionStorage.setItem(this.$attrs.chapterId + '_fxText', this.fxText)
                    sessionStorage.setItem('apartStatus', JSON.stringify({ id: this.$attrs.chapterId, status: 'ok' }))
                    if (!this.$attrs.result) {
                        this.$parent.$parent.refreshList(this.$attrs.chapterId)
                    }
                    this.$message.success('AI生成完成！');
                    this.stopPolling();
                } else {
                    this.getGeneratorText(id)
                }
            });
        },
        textContentLength(type) {
            if (type === 'cs' && this.csText) {
                return this.csText.replace(/<[^>]+>/g, '').length
            }
            // if (type === 'fx' && this.fxText) {
            //     return this.fxText.replace(/<[^>]+>/g, '').length
            // }
            return 0
        },
        replaceText(text) {
            if (!text) return ''
            return text.replace(/^-(>|&gt;)(.*?)\n/gm, '<p class="main-title" style="font-size:16px;font-weight:bold;line-height:30px;" class="content-title">$2</p>').replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
        },
        // 打字机效果
        startTypewriterEffect(text, callback) {
            let index = 0
            if (this.typewriterInterval) {
                clearInterval(this.typewriterInterval);
            }
            this.typewriterInterval = setInterval(() => {
                if (index < text.length) {
                    if (this.activeName === 'cs') {
                        this.csText += text[index]
                        index++;
                        this.scrollToBottom('csRef');
                    }
                    // else if (this.activeName === 'fx') {
                    //     this.fxText += text[index]
                    //     index++;
                    //     this.scrollToBottom('fxRef');
                    // }
                } else {
                    clearInterval(this.typewriterInterval);
                    if (callback) {
                        callback();
                    }
                }
            }, this.typewriterSpeed);
        },
        // 滚动到底部
        scrollToBottom(refName) {
            this.$nextTick(() => {
                const container = this.$refs[refName];
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },
        // 滚动到顶部
        scrollToTop(refName) {
            this.$nextTick(() => {
                const container = this.$refs[refName];
                if (container) {
                    container.scrollTop = 0;
                }
            });
        },
    },
    destroyed() {
        this.stopPolling()
    }
}
</script>
<style lang="scss" scoped>
p,
h1,
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}

::v-deep .main-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 30px;
}

.classify {
    display: flex;
    flex: 1;
    flex-direction: column;
    font-family: Microsoft YaHei, Microsoft YaHei;
    position: relative;

    .tabs {
        margin: 0 20px;
    }

    h1 {
        height: 64px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .loading {
            position: absolute;
            left: 30px;
            font-size: 15px;
            // img {
            //     width: 20px;
            //     height: 20px;
            //     animation: rotate 1s linear infinite;
            // }
        }

        .title {
            font-weight: bold;
            font-size: 18px;
            color: #0A0A0A;
            line-height: 16px;
        }

        .statusText {
            position: absolute;
            right: 30px;
            font-size: 15px;
            color: #444444;
            ;
        }
    }

    .main {
        // margin-top: 16px;
        padding: 0 24px 20px;
        overflow: auto;
        z-index: 2;
        flex: 1;
        position: relative;
        white-space: pre-wrap;
        /* 保留换行和空格 */
        @include no_scrollbar();

        .content-title {
            font-size: 16px;
            font-weight: bold;
            color: #0A0A0A;
        }
    }


}

.bottom-btn {
    height: 66px;
    width: 100%;
    background: #FFFFFF;
    border-top: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
        // width: 120px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--tech-primary);
        border-radius: 8px;
        border: none;
        cursor: pointer;

        &:hover {
            opacity: 0.8;
        }

        span {
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 16px;
        }
    }

    .default {
        background-color: #ffffff;
        border: 1px solid var(--tech-primary);

        span {
            color: var(--tech-primary);
        }
    }
}

/* 定义旋转动画 */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>